import React from 'react';
import {
  Alert, Box, Button, Typography,
} from '@mui/material';
import { useCkInside } from '@NP-Webber/crm-kit/dist/next/index.js';
import { READER_ID, useBarcodeCamera } from './barcodeCamera.js';
import { BarcodeCameraPanelNext } from './ScanNext.jsx';

/**
 * פאנל סריקת ברקוד מוטמע (מצלמת מכשיר) — סריקה רציפה בלי חלון קופץ.
 * הסטרים נשאר חי בין סריקות; paused מונע onScan בלי לסגור את המצלמה.
 * בעיצוב החדש — BarcodeCameraPanelNext עם אותו hook.
 */
const BarcodeCameraPanel = (props) => (useCkInside() ? <BarcodeCameraPanelNext {...props} /> : <BarcodeCameraPanelLegacy {...props} />);

const BarcodeCameraPanelLegacy = ({ active, paused = false, onScan, onStop }) => {
  const { error, starting } = useBarcodeCamera({ active, paused, onScan });

  if (!active) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {paused
            ? 'סריקה מושהית — לאחר סגירת החלון תמשיך אוטומטית'
            : 'כוונו את הברקוד למרכז. סריקה רציפה — אפשר לסרוק אחד אחרי השני'}
        </Typography>
        <Button size="small" onClick={onStop} variant="outlined" color="inherit">
          עצור מצלמה
        </Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
      {starting && !error && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          מפעיל מצלמה…
        </Typography>
      )}
      <Box
        id={READER_ID}
        sx={{
          width: '100%',
          minHeight: { xs: 320, sm: 400 },
          borderRadius: 1,
          overflow: 'hidden',
          bgcolor: 'black',
          opacity: paused ? 0.55 : 1,
          transition: 'opacity 0.2s',
          '& video': {
            borderRadius: 1,
            width: '100% !important',
            maxHeight: { xs: 360, sm: 480 },
            objectFit: 'cover',
          },
        }}
      />
    </Box>
  );
};

export default BarcodeCameraPanel;
